const environmentVariables = {
  graphqlBaseUrl: 'https://titiro-preprod-be.hextra.dev/graphql'
};

export default environmentVariables;
